import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { getErrorMessage } from "../../utils/errorUtils";
import * as actions from "../slices/license";

export const getLicenses =
  ({ search = "", status = "", startDate, endDate, page = 1, size = 10 }) =>
  async (dispatch) => {
    dispatch(actions.setLoadingLicenses());
    try {
      const params = { page, size, startDate, endDate };
      if (search) params.search = search;
      if (status) params.status = status;

      const { data } = await axiosInstance.get("/licenses", {
        params,
        headers: { requiresAuth: true },
      });
      if (data.status === "SUCCESS") {
        dispatch(
          actions.setLicenses({
            content: data.data.content,
            pagination: data.data.pagination,
          }),
        );
      }
    } catch (error) {
      dispatch(actions.setErrorLoadingLicenses(getErrorMessage(error)));
    }
  };

export const getLicenseById = (id) => async (dispatch) => {
  dispatch(actions.setLoadingLicense());
  try {
    const { data } = await axiosInstance.get(`/licenses/${id}`, {
      headers: { requiresAuth: true },
    });
    if (data.status === "SUCCESS")
      dispatch(actions.setCurrentLicense(data.data));
  } catch (error) {
    dispatch(actions.setErrorLoadingLicense(getErrorMessage(error)));
  }
};

export const createLicense = (payload) => async (dispatch) => {
  dispatch(actions.setLoadingCreate());
  try {
    const { data } = await axiosInstance.post("/licenses", payload, {
      headers: { requiresAuth: true },
    });
    if (data.status === "SUCCESS") {
      toast.success(data.message || "License created successfully!");
      dispatch(actions.createLicenseSuccess(data.data));
      dispatch(
        actions.setServerResponseStatus({
          operation: "create",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const msg = getErrorMessage(error);
    toast.error(msg);
    dispatch(actions.setErrorCreating(msg));
  }
};

export const updateLicense = (id, payload) => async (dispatch) => {
  dispatch(actions.setLoadingUpdate());
  try {
    const { data } = await axiosInstance.put(`/licenses/${id}`, payload, {
      headers: { requiresAuth: true },
    });
    if (data.status === "SUCCESS") {
      toast.success(data.message || "License updated!");
      dispatch(actions.updateLicenseSuccess(data.data));
      dispatch(
        actions.setServerResponseStatus({
          operation: "update",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const msg = getErrorMessage(error);
    toast.error(msg);
    dispatch(actions.setErrorUpdating(msg));
  }
};

export const deleteLicense = (id) => async (dispatch) => {
  dispatch(actions.setLoadingDelete());
  try {
    const { data } = await axiosInstance.delete(`/licenses/${id}`, {
      headers: { requiresAuth: true },
    });
    if (data.status === "SUCCESS") {
      toast.success(data.message || "License deleted!");
      dispatch(actions.deleteLicenseSuccess(id));
      dispatch(
        actions.setServerResponseStatus({
          operation: "delete",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const msg = getErrorMessage(error);
    toast.error(msg);
    dispatch(actions.setErrorDeleting(msg));
  }
};

export const revokeLicense = (id) => async (dispatch) => {
  dispatch(actions.setLoadingRevoke());
  try {
    const { data } = await axiosInstance.patch(`/revoke/licenses/${id}`, null, {
      headers: { requiresAuth: true },
    });
    if (data.status === "SUCCESS") {
      toast.success(data.message || "License revoked!");
      dispatch(actions.updateLicenseSuccess(data.data));
      dispatch(
        actions.setServerResponseStatus({
          operation: "revoke",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const msg = getErrorMessage(error);
    toast.error(msg);
    dispatch(actions.setErrorRevoking(msg));
  }
};

export const upgradeLicense = (id, payload) => async (dispatch) => {
  dispatch(actions.setLoadingUpgrade());
  try {
    const { data } = await axiosInstance.patch(
      `/licenses/${id}/upgrade`,
      payload,
      { headers: { requiresAuth: true } },
    );
    if (data.status === "SUCCESS") {
      toast.success(data.message || "License upgraded!");
      dispatch(actions.updateLicenseSuccess(data.data));
      dispatch(
        actions.setServerResponseStatus({
          operation: "upgrade",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const msg = getErrorMessage(error);
    toast.error(msg);
    dispatch(actions.setErrorUpgrading(msg));
  }
};

export const resetLicenseServerStatus = () => (dispatch) => {
  dispatch(actions.setServerResponseStatus(null));
};
